import React, { useRef, useState } from 'react';

import GlobeIcon from '@/assets/icons/globe.svg';

import { HreflangTag } from '@/helpers/rendered-page-creation/calculate-hreflang-tags';
import { useOnClickOutside } from '@/hooks';
import { IMeetingPlacePageLanding } from '@/lib/fragments/meetingPlacePageLanding';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import { LanguageSelectorWidget } from '../language-selector/language-selector-widget';

interface LandingPageHeaderProps {
  page: IMeetingPlacePageLanding;
  hrefLangTags: HreflangTag[];
}
export const LandingPageHeader = ({
  page,
  hrefLangTags,
}: LandingPageHeaderProps) => {
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  const toggleLanguageSelector = () =>
    setShowLanguageSelector(!showLanguageSelector);

  const refLanguageSelector = useRef(null);
  const aspectRatio =
    page?.logo?.width && page?.logo?.height
      ? parseInt(page?.logo?.width) / parseInt(page?.logo?.height)
      : undefined;

  useOnClickOutside(
    refLanguageSelector,
    () => setShowLanguageSelector(false),
    false,
    ['language-selector-trigger-button'],
  );

  return (
    <div className="z-10 flex w-full justify-between px-5 pt-10 lg:px-8 lg:pt-8">
      {page?.logo && (
        <ImageWrapper
          alt={page.logo?.description}
          url={page?.logo?.url}
          className={aspectRatio == 1 ? 'max-h-15 w-36' : 'max-h-10 w-36'}
          imgClassName={
            aspectRatio == 1 ? 'max-h-15 !w-auto' : 'max-h-10 !w-auto'
          }
          width={144}
          height={aspectRatio == 1 ? 60 : 40}
        />
      )}
      {page.showLanguageSelector && (
        <div className="flex flex-col items-end">
          <button
            id="language-selector-trigger-button"
            type="button"
            onClick={toggleLanguageSelector}
            className="grid h-12 w-12 place-items-center rounded-full bg-neutral-grey-100 text-icon-dark outline-0 transition-all lg:hover:bg-neutral-grey-200 focus-visible:bg-neutral-grey-100 focus-visible:outline-icon-dark active:bg-neutral-grey-300 lg:focus-visible:outline lg:focus-visible:outline-3 lg:focus-visible:outline-offset-3"
            aria-expanded={showLanguageSelector}
            aria-controls="language-selector"
            aria-label="Select language"
          >
            <GlobeIcon width="20" height="21" className="fill-current" />
          </button>

          <LanguageSelectorWidget
            el={refLanguageSelector}
            hrefLangTags={hrefLangTags}
            node_locale={page?.sys?.locale}
            primaryLanguage={page?.defaultLanguage}
            secondaryLanguages={page?.languagesCollection?.items ?? []}
            languageSelectorClass={`absolute top-24 lg:top-20 ${
              showLanguageSelector ? 'lg:mt-4' : 'hidden'
            }`}
            variant="dropdown"
          />
        </div>
      )}
    </div>
  );
};
